/** These are the list of error codes which could lead to the failure of installing an app.
 * They are divided into 3 categories as per their owners: Atlassian, Partner & Customer
 * Also there is information added about the services for each of the error codes.
 */
var Owners = /*#__PURE__*/function (Owners) {
  Owners[Owners["Downstream"] = 0] = "Downstream";
  Owners[Owners["Marketplace"] = 1] = "Marketplace";
  Owners[Owners["Partner"] = 2] = "Partner";
  Owners[Owners["Customer"] = 3] = "Customer";
  return Owners;
}(Owners || {});
var Services = /*#__PURE__*/function (Services) {
  Services[Services["UPM"] = 0] = "UPM";
  Services[Services["COFS"] = 1] = "COFS";
  Services[Services["TCS"] = 2] = "TCS";
  Services[Services["Connect"] = 3] = "Connect";
  Services[Services["CAAS"] = 4] = "CAAS";
  Services[Services["AppCatalog"] = 5] = "AppCatalog";
  Services[Services["BAG"] = 6] = "BAG";
  Services[Services["Demand"] = 7] = "Demand";
  Services[Services["CCP"] = 8] = "CCP";
  Services[Services["Marketplace"] = 9] = "Marketplace";
  return Services;
}(Services || {});
const AppInstallAtlassianErrorCodeOwnership = {
  'upm.plugin.error.install.error': {
    primaryOwner: Owners.Marketplace,
    services: [Services.UPM]
  },
  'upm.plugin.error.timeout.license.change': {
    primaryOwner: Owners.Downstream,
    otherOwners: [Owners.Customer],
    services: [Services.COFS, Services.Marketplace]
  },
  'upm.error.invalid.token ': {
    primaryOwner: Owners.Marketplace,
    services: [Services.Marketplace]
  },
  UPMTokenFetchError: {
    primaryOwner: Owners.Marketplace,
    services: [Services.Marketplace]
  },
  UPMInstallPostError: {
    primaryOwner: Owners.Marketplace,
    services: [Services.UPM]
  },
  FetchAddonInternalError: {
    primaryOwner: Owners.Marketplace,
    services: [Services.TCS, Services.Marketplace]
  },
  AppProvisioningError: {
    primaryOwner: Owners.Downstream,
    services: [Services.CCP]
  },
  Undefined: {
    primaryOwner: Owners.Marketplace,
    services: [Services.Marketplace]
  },
  FetchError: {
    primaryOwner: Owners.Marketplace,
    services: [Services.Marketplace]
  },
  GraphQLFetchError: {
    primaryOwner: Owners.Marketplace,
    services: [Services.Marketplace]
  },
  'unexpected.exception': {
    primaryOwner: Owners.Marketplace,
    services: [Services.Marketplace]
  },
  '12': {
    primaryOwner: Owners.Marketplace,
    services: [Services.Marketplace]
  },
  APP_REACTIVATION_NOT_SUPPORTED: {
    primaryOwner: Owners.Downstream,
    services: [Services.CCP, Services.Marketplace]
  },
  AppInstallationTaskFailedError: {
    primaryOwner: Owners.Downstream,
    services: [Services.CAAS]
  },
  'EcosystemCloudInstallPollFailure-unknown.error.code': {
    primaryOwner: Owners.Downstream,
    services: [Services.CAAS]
  },
  EcosystemCloudAppFetchFailed: {
    primaryOwner: Owners.Downstream,
    services: [Services.CAAS]
  },
  'cofs.billingApi.exception': {
    primaryOwner: Owners.Downstream,
    services: [Services.BAG]
  },
  'connect.install.error.conflicting.macro.alias': {
    primaryOwner: Owners.Downstream,
    otherOwners: [Owners.Partner],
    services: [Services.Connect, Services.CAAS, Services.Marketplace]
  },
  'connect.install.error.dependencies.failed': {
    primaryOwner: Owners.Downstream,
    services: [Services.Connect, Services.Marketplace]
  },
  'connect.install.error.duplicate.macro.keys': {
    primaryOwner: Owners.Downstream,
    services: [Services.Connect]
  },
  /** Errors thrown via Store BFF flow */
  InvalidInstallationTargetInfo: {
    primaryOwner: Owners.Marketplace,
    services: [Services.Marketplace]
  },
  UnknownErrorInMarketplaceStoreAppInstall: {
    primaryOwner: Owners.Marketplace,
    services: [Services.Marketplace]
  },
  UNSUPPORTED_BILLING_SYSTEM: {
    primaryOwner: Owners.Marketplace,
    services: [Services.Marketplace]
  },
  APP_ALREADY_PROVISIONED: {
    primaryOwner: Owners.Downstream,
    services: [Services.COFS, Services.Marketplace],
    isIgnoreable: true
  },
  PAYMENT_MODEL_NOT_FOUND: {
    primaryOwner: Owners.Downstream,
    services: [Services.AppCatalog]
  },
  INCOMPATIBLE_PRODUCT: {
    primaryOwner: Owners.Marketplace,
    services: [Services.AppCatalog, Services.Marketplace]
  },
  FREE_APPS_PROVISIONING_NOT_SUPPORTED: {
    primaryOwner: Owners.Marketplace,
    services: [Services.Marketplace]
  },
  TRANSACTION_ACCOUNT_ID_NOT_FOUND: {
    primaryOwner: Owners.Downstream,
    services: [Services.CCP]
  },
  CCP_ENTITLEMENT_RELATIONSHIP_NOT_FOUND: {
    primaryOwner: Owners.Downstream,
    services: [Services.CCP]
  },
  NO_RESOURCE_PACKAGE_FOUND: {
    primaryOwner: Owners.Downstream,
    services: [Services.COFS]
  },
  PAYMENT_MODEL_NOT_SUPPORTED_FOR_INSTALLATION: {
    primaryOwner: Owners.Marketplace,
    services: [Services.Marketplace]
  },
  APP_ENTITLEMENT_SUSPENDED: {
    primaryOwner: Owners.Downstream,
    services: [Services.CCP],
    isIgnoreable: true
  }
};
const AppInstallationPartnerErrorCodeOwnership = {
  /* The following category of errors are only fixable by the partner */
  'connect.install.error.remote.host.bad.response': {
    primaryOwner: Owners.Partner,
    services: [Services.Connect]
  },
  'connect.install.error.remote.host.bad.response.400': {
    primaryOwner: Owners.Partner,
    services: [Services.Connect]
  },
  'connect.install.error.remote.host.bad.response.401': {
    primaryOwner: Owners.Partner,
    services: [Services.Connect]
  },
  'connect.install.error.remote.host.bad.response.402': {
    primaryOwner: Owners.Partner,
    services: [Services.Connect]
  },
  'connect.install.error.remote.host.bad.response.403': {
    primaryOwner: Owners.Partner,
    services: [Services.Connect]
  },
  'connect.install.error.remote.host.bad.response.404': {
    primaryOwner: Owners.Partner,
    services: [Services.Connect]
  },
  'connect.install.error.remote.host.bad.response.500': {
    primaryOwner: Owners.Partner,
    services: [Services.Connect]
  },
  'connect.install.error.remote.host.bad.response.501': {
    primaryOwner: Owners.Partner,
    services: [Services.Connect]
  },
  'connect.install.error.remote.host.bad.response.502': {
    primaryOwner: Owners.Partner,
    services: [Services.Connect]
  },
  'connect.install.error.remote.host.bad.response.503': {
    primaryOwner: Owners.Partner,
    services: [Services.Connect]
  },
  'connect.install.error.remote.host.bad.domain': {
    primaryOwner: Owners.Partner,
    services: [Services.Connect]
  },
  'connect.install.error.remote.host.timeout': {
    primaryOwner: Owners.Partner,
    services: [Services.Connect]
  },
  'connect.install.error.remote.host.ssl': {
    primaryOwner: Owners.Partner,
    services: [Services.Connect]
  },
  'connect.install.error.unknown.module': {
    primaryOwner: Owners.Partner,
    services: [Services.Connect]
  },
  'connect.install.error.remote.descriptor.validation': {
    primaryOwner: Owners.Partner,
    services: [Services.Connect]
  },
  'connect.install.error.deprecated.context.iframe.url': {
    primaryOwner: Owners.Partner,
    services: [Services.Connect]
  },
  'connect.install.error.auth.with.no.installed.callback': {
    primaryOwner: Owners.Partner,
    services: [Services.Connect]
  },
  'connect.install.error.page.with.invalid.condition': {
    primaryOwner: Owners.Partner,
    services: [Services.Connect]
  },
  'connect.install.error.page.with.invalid.property': {
    primaryOwner: Owners.Partner,
    services: [Services.Connect]
  },
  'connect.install.error.webhook.with.invalid.condition': {
    primaryOwner: Owners.Partner,
    services: [Services.Connect]
  },
  'connect.install.error.missing.scope': {
    primaryOwner: Owners.Partner,
    services: [Services.Connect]
  },
  'connect.install.error.no.modules': {
    primaryOwner: Owners.Partner,
    services: [Services.Connect]
  },
  'connect.install.error.base_url.invalid_host': {
    primaryOwner: Owners.Partner,
    services: [Services.Connect]
  },
  'connect.install.error.base_url.no_tls': {
    primaryOwner: Owners.Partner,
    services: [Services.Connect]
  },
  'connect.install.error.invalid.location': {
    primaryOwner: Owners.Partner,
    services: [Services.Connect]
  },
  'connect.install.error.invalid.location.mobile': {
    primaryOwner: Owners.Partner,
    services: [Services.Connect]
  },
  'connect.install.error.invalid.platform.mobile': {
    primaryOwner: Owners.Partner,
    services: [Services.Connect]
  },
  'connect.install.error.invalid.condition.parameters': {
    primaryOwner: Owners.Partner,
    services: [Services.Connect]
  },
  'connect.install.error.missing.url': {
    primaryOwner: Owners.Partner,
    services: [Services.Connect]
  },
  'connect.install.error.region.unsupported': {
    primaryOwner: Owners.Partner,
    otherOwners: [Owners.Marketplace],
    services: [Services.Connect]
  },
  'connect.install.error.data.resident.validation.failed': {
    primaryOwner: Owners.Partner,
    services: [Services.Connect]
  },
  'connect.install.error.blueprint.description.too_long': {
    primaryOwner: Owners.Partner,
    services: [Services.Connect]
  },
  'connect.install.error.url.and.target.dialog.key': {
    primaryOwner: Owners.Partner,
    services: [Services.Connect]
  },
  'connect.install.error.invalid.target.dialog.key': {
    primaryOwner: Owners.Partner,
    services: [Services.Connect]
  },
  'connect.install.error.invalid.cacheable.iframe.url': {
    primaryOwner: Owners.Partner,
    services: [Services.Connect]
  },
  'connect.install.error.webitem.dialogmodule.cacheable': {
    primaryOwner: Owners.Partner,
    services: [Services.Connect]
  },
  'connect.install.error.webitem.pagecontext.cacheable': {
    primaryOwner: Owners.Partner,
    services: [Services.Connect]
  },
  'connect.install.error.webhooks.url-params.deprecated': {
    primaryOwner: Owners.Partner,
    services: [Services.Connect]
  },
  'connect.install.error.missing.dialogmodule.item.options': {
    primaryOwner: Owners.Partner,
    services: [Services.Connect]
  },
  'connect.install.error.invalid.dialogoptions.dimension': {
    primaryOwner: Owners.Partner,
    services: [Services.Connect]
  },
  'connect.install.error.invalid.dialogoptions.dimensions': {
    primaryOwner: Owners.Partner,
    services: [Services.Connect]
  },
  'connect.install.error.dependencies.disabled': {
    primaryOwner: Owners.Partner,
    services: [Services.Connect]
  },
  'connect.install.error.dependencies.multilevel.failed': {
    primaryOwner: Owners.Partner,
    services: [Services.Connect]
  },
  'connect.install.error.marketplace.no.public.versions': {
    primaryOwner: Owners.Partner,
    services: [Services.Connect]
  },
  'connect.install.error.i18n.disabled': {
    primaryOwner: Owners.Partner,
    services: [Services.Connect]
  },
  'connect.install.error.i18n.download.malformed': {
    primaryOwner: Owners.Partner,
    services: [Services.Connect]
  },
  'connect.install.error.i18n.download.value.long': {
    primaryOwner: Owners.Partner,
    services: [Services.Connect]
  },
  'connect.install.error.duplicate.module.keys': {
    primaryOwner: Owners.Partner,
    services: [Services.Connect]
  },
  'connect.install.error.entity_properties.modules.disabled': {
    primaryOwner: Owners.Partner,
    otherOwners: [Owners.Marketplace],
    services: [Services.Connect]
  },
  'connect.install.error.user.provisioning': {
    primaryOwner: Owners.Partner,
    services: [Services.Connect]
  },
  'connect.install.error.jira.issue.alpha': {
    primaryOwner: Owners.Partner,
    otherOwners: [Owners.Marketplace],
    services: [Services.Connect]
  },
  'connect.remote.upm.install.exception': {
    primaryOwner: Owners.Partner,
    services: [Services.Connect]
  },
  'upm.pluginInstall.error.response.exception': {
    primaryOwner: Owners.Partner,
    otherOwners: [Owners.Marketplace],
    services: [Services.UPM]
  },
  'upm.pluginInstall.error.install.failed': {
    primaryOwner: Owners.Partner,
    services: [Services.UPM]
  },
  'upm.pluginInstall.error.unknown.plugin.type': {
    primaryOwner: Owners.Partner,
    services: [Services.UPM]
  },
  'upm.pluginInstall.error.ssl': {
    primaryOwner: Owners.Partner,
    services: [Services.UPM]
  },
  'connect.install.error.not.email.approved': {
    primaryOwner: Owners.Partner,
    services: [Services.Connect]
  }
};
const AppInstallCustomerErrorCodeOwnership = {
  /** This error is when the user has failed to update payment details in their instance */
  'connect.remote.upm.install.payment.failure.exception': {
    primaryOwner: Owners.Customer,
    services: [Services.Connect]
  },
  /** This error is when installation for the same forge app is already in progress - [MC-2837] */
  TASK_ALREADY_EXISTS: {
    primaryOwner: Owners.Customer,
    services: [Services.Marketplace]
  },
  /** Ignore erros specific to forge apps when install fails due to customer account pending renewal */
  'EcosystemCloudInstallPollFailure-account.pending.renewal': {
    primaryOwner: Owners.Customer,
    services: [Services.CAAS]
  },
  'connect.install.error.addon.admin.permission': {
    primaryOwner: Owners.Customer,
    services: [Services.Connect]
  },
  'connect.install.error.locked': {
    primaryOwner: Owners.Customer,
    services: [Services.Connect]
  },
  'connect.install.error.nodefaultgroup': {
    primaryOwner: Owners.Customer,
    services: [Services.Connect]
  },
  /** This can occur if the parent product does not have an active license.*/
  NO_CCP_ENTITLEMENT_FOR_PRODUCT: {
    primaryOwner: Owners.Customer,
    services: [Services.CCP]
  }
};
export { AppInstallationPartnerErrorCodeOwnership, AppInstallAtlassianErrorCodeOwnership, AppInstallCustomerErrorCodeOwnership, Owners };